import React, { useEffect } from "react";
import { AdminTable } from "./AdminTable";
import { useDispatch, useSelector } from "react-redux";
import { Column } from "devextreme-react/data-grid";
import { useState } from "react";
import { openModal } from "../../redux/modal/modalSlice";
import { selectInteractions, selectInteractionsLoading } from "../../redux/interactions/selectors";
import { createInteraction, deleteInteraction, editInteraction, getInteractionsPag } from "../../redux/interactions/thunks";
import { selectCaseStates } from "../../redux/caseStates/selectors";
import { getCaseStates } from "../../redux/caseStates/thunks";
import { selectUsers } from "../../redux/users/selectors";
import { getUsers } from "../../redux/users/thunks";
import { getTaxonomyDescriptions } from "../../redux/taxonomyDescriptions/thunks";
import { selectTaxonomyDescriptions, selectTaxonomyDescriptionsLoading } from "../../redux/taxonomyDescriptions/selectors";
import { renderCaseStateColumn } from "../../Constantes/constantesColumnasTablas";
import { useTranslation } from "react-i18next";

const initialSortOptions = {
    columna: "interactionId",
    sortOrderAsc: true

}

function InteractionManagement() {
    const { t } = useTranslation();
    const interactions = useSelector(selectInteractions);
    const caseStates = useSelector(selectCaseStates);
    const users = useSelector(selectUsers); 
    const dispatch = useDispatch();
    const loadingInteractions = useSelector(selectInteractionsLoading);
    const taxonomyDescriptions = useSelector(selectTaxonomyDescriptions)
    const loadingTaxonomies = useSelector(selectTaxonomyDescriptionsLoading)
    const [sortOptions, setSortOptions] = useState(initialSortOptions) 
    const loading = (loadingInteractions !== "succeeded" && loadingTaxonomies !== "succeeded") ? "loading" : "succeeded"

    useEffect(()=>{
        getListInteractions(mapPageInfo(interactions));
        dispatch(getCaseStates());
        dispatch(getUsers());
        dispatch(getTaxonomyDescriptions());

    }, [])

    function mapPageInfo(interactionsData){
        return {
            pageIndex: interactionsData.pageIndex ?? 0,
            pageSize: interactionsData.pageSize ?? 10,
            orderByField:  interactionsData.columna ?? "interactionId",
            orderByAscending:  interactionsData.sortOrderAsc ?? true
        }
    }
      
    const getListInteractions = (pageInfo) => {
        let query = `?pageIndex=${pageInfo.pageIndex}&pageNum=${pageInfo.pageSize}`
        if(pageInfo.searchString?.trim().length > 0){
            query = query.concat(`&searchString=${pageInfo.searchString.trim()}`)
        }
        if(pageInfo.orderByField)
            {
                query = query.concat(`&orderByField=${pageInfo.orderByField}&orderByAscending=${pageInfo.orderByAscending}`)
            }
        dispatch(getInteractionsPag({query}));
    }

    const columnsInteractions = [
        <Column dataType={"string"} sortIndex={1} key={"interaction-1"} width="8%" dataField="interactionCode" caption="Código Interação" />, 
        <Column lookup={{allowClearing: false, dataSource: caseStates, displayExpr:'description', valueExpr: 'stateId'}} dataField="caseStateId" cellRender={(data)=>renderCaseStateColumn(data.value, data.text)}  key={"interaction-2"} width="10%" caption="Estado de caso"></Column>, 
        <Column lookup={{dataSource: users, displayExpr: "userName", valueExpr: "userId"}} dataField={"userId"} key={"interaction-3"} width="8%" caption={t("User")}></Column>, 
        <Column dataType={"string"} key={"interaction-4"} width="45%" dataField="comment" caption={t("Comment")}/>, 
        <Column key={"interaction-5"} width="22%" dataField="taxonomy" cellRender={({value})=>renderTaxonomyCell([value])} dataType={"taxonomy"}  caption={t("Taxonomy")}></Column>, 
        // <Column dataType={"string"} key={"interaction-6"} width="45%" dataField="promptDescription" caption="Prompt"/>, 
    ] 

    function renderTaxonomyCell(rowTaxonomies){
        const toDescriptions= rowTaxonomies.map(rt=> transformToTaxonomyDescriptions(rt))
        
        return(
            <div style={{display: "flex", flexDirection: "column", rowGap: "0.25rem"}}>
                {toDescriptions.map(d=><div key={d}>{d}</div>)}
            </div>
        )
    }

    function transformToTaxonomyDescriptions(taxonomy){
        if(taxonomy){
            const descriptionArray = [];
            if(taxonomy.level_1)
                descriptionArray.push(taxonomyDescriptions.find(td=> td.key === taxonomy.level_1)?.value);
            if(taxonomy.level_2)
                descriptionArray.push(taxonomyDescriptions.find(td=> td.key === taxonomy.level_2)?.value)
            if(taxonomy.level_3)
                descriptionArray.push(taxonomyDescriptions.find(td=> td.key === taxonomy.level_3)?.value)
            if(taxonomy.level_4)
                descriptionArray.push(taxonomyDescriptions.find(td=> td.key === taxonomy.level_4)?.value)
            
            return  descriptionArray.join(", ")
        }
        return [""]
    }


    function handleSaveNewInteractionClick(value, closeCreateModal) {   

        const taxonomyValue = {
            taxonomyLevel_1 : value.taxonomy?.level_1,
            taxonomyLevel_2 : value.taxonomy?.level_2,
            taxonomyLevel_3 : value.taxonomy?.level_3,
            taxonomyLevel_4 : value.taxonomy?.level_4
        }
        const body = {...value, taxonomy: taxonomyValue}

        if(!validateInteractionData(body))
            return

        const interactionParams ={
                    body,
                    interactionId: value.interactionId
                }
            dispatch(createInteraction(interactionParams)).then((data) => {
                    if(data.error)
                        dispatch(openModal({ type: "warning", message:data.error.message}))
                    else{
                        getListInteractions(mapPageInfo({...interactions, ...sortOptions}));
                        closeCreateModal();
                    }                    
                })
    }    

    function handleEditClick(value, closeEditModal) {

        const taxonomyValue = {
            taxonomyLevel_1 : value.taxonomy?.level_1,
            taxonomyLevel_2 : value.taxonomy?.level_2,
            taxonomyLevel_3 : value.taxonomy?.level_3,
            taxonomyLevel_4 : value.taxonomy?.level_4
        }

        const body = {...value, taxonomy: taxonomyValue}

        if(!validateInteractionData(body))
            return

        dispatch(editInteraction({body, param: value.interactionId})).then((data) => {
                    if(data.error)
                        dispatch(openModal({ type: "warning", message:data.error.message}))
                    else{
                        getListInteractions(mapPageInfo({...interactions, ...sortOptions}));
                        closeEditModal();
                    }    
                })
            }
                   
    const handleDeleteClick = (id, closeEditModal) => {
        dispatch(deleteInteraction(id)).then((data) => {
            if(data.error)
                dispatch(openModal({ type: "warning", message:data.error.message}))
            else{
                let updatedPageIndex = interactions.pageIndex;

                if (interactions.elements.length === 1) {
                    updatedPageIndex = Math.max(0, interactions.pageIndex - 1);
                }

                const updatedInteractions = {
                    ...interactions,
                    pageIndex: updatedPageIndex,
                };

                getListInteractions(mapPageInfo({...updatedInteractions, ...sortOptions}));
                closeEditModal();               
            }
        })  
    }


    function validateInteractionData(submitData)
    {
        if(!submitData.interactionCode || submitData.interactionCode?.trim() === "")
        {
            dispatch(openModal({type: "warning", message: "El campo Código Interacción es obligatorio"}))
            return false;
        }
        if(!submitData.caseStateId)
        {
            dispatch(openModal({type: "warning", message: "El campo Estado del Caso es obligatorio"}))
            return false;
        }
        if(!submitData.userId)
        {
                dispatch(openModal({type: "warning", message: "El campo Usuario es obligatorio"}))
                return false;
        }
        if(!submitData.comment ||submitData.comment.trim() === "")
        {
            dispatch(openModal({type: "warning", message: "El campo Comentario es obligatorio"}))
            return false
        }

        return true

    }

    return(
        <div style={{width: "100%"}}>
            <AdminTable 
                sectionTitle={t("Interactions")}
                masterTitle={t("Interaction")}
                itemIdField={"interactionId"} 
                itemDescriptionField={"interactionCode"} 
                loading={loading} 
                getData={getListInteractions} 
                dataSource={loading !== "succeeded"? [] : interactions} 
                columnasTabla={columnsInteractions} 
                numElements={[10, 20, 30]} 
                onCreate={handleSaveNewInteractionClick}
                onDelete={handleDeleteClick}
                onEdit={handleEditClick} 
                sortField={sortOptions}
                dialogSize={{height: "100%", width: "fit-content"}}
                setsortField={setSortOptions}
            />               
        </div>
    )
}
export default InteractionManagement;